var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupiconhuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.7 31.6",
    enableBackground: "new 0 0 36.7 31.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M23.1,19.1c-0.2-0.6-0.6-1.2-1.2-1.7 c-0.4-0.4-0.9-0.6-1.3-0.7l-3.4-1c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.3-0.3-0.5l-0.2-1.4c1-0.7,1.7-1.9,2-3.2 c0.6-0.1,1.1-0.7,1.1-1.6c0-0.8-0.4-1.4-0.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M20.2,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M8.9,7.4C8.4,7.6,8,8.2,8,9 c0,0.9,0.5,1.5,1.1,1.6c0.3,1.3,1.1,2.4,2,3.2l-0.2,1.4c0,0.2-0.1,0.4-0.3,0.5c-0.1,0-0.1,0.1-0.2,0.1l-3.4,1 c-0.4,0.1-0.9,0.3-1.3,0.7c-0.7,0.6-1.2,1.4-1.4,2.3l-0.8,4c0,0.1,0,0.1,0,0.2c0,0,0.1,0.1,0.1,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M18.6,7.4c0,0,0.3-5.7-4.8-5.7 S8.9,7.4,8.9,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M9.3,5c0.2-0.4,0.6-0.7,1-0.9 C11,3.8,11.8,4,12.4,4.3c1,0.4,1.8,1,2.9,1.1c1,0.1,2,0,2.9-0.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 10.6,
    y1: 15.6,
    x2: 13.8,
    y2: 18.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 16.9,
    y1: 15.6,
    x2: 13.8,
    y2: 18.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    cx: 27.1,
    cy: 23.8,
    r: 5.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 27.1,
    y1: 26.7,
    x2: 27.1,
    y2: 20.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 24.2,
    y1: 23.8,
    x2: 29.9,
    y2: 23.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupiconhuman);
export default __webpack_public_path__ + "static/media/Signup icon  human.c2bc5f17253b7b76fd1a1a722e6721ef.svg";
export { ForwardRef as ReactComponent };